export default __webpack_public_path__ + "static/media/calendar-icon.05b71830.svg";